module.exports = __webpack_public_path__ + "static/media/bill.cdfbe03f.svg";